const main = {
  deepSkyBlue: '#0189FF',
  azureRadiance: '#017BE5',
  blueGrey: '#60798E',
  veryLightBlue: '#E0EEFA',
  linkWater: '#C7DEF2',
  ziggurat: '#B0CFE0',
}

/**
 * Valores definidos en el sistema de diseños eclass.
 * @see https://zeroheight.com/15698077d/p/435a07-paleta-de-colores
 */
export const colors = {
  main,
  secondary: {
    pumpkin: '#FF7A14',
    polishedBronze: '#CD7F32',
    cornsilk: '#FFF5DF',
    linen: '#F8ECE0',
  },
  alert: {
    deepSkyBlue: main.deepSkyBlue,
    veryLightBlue: main.veryLightBlue,
    jadeGreen: '#28A745',
    ice: '#E9F6EC',
    red: '#CC0000',
    veryLightPinkThree: '#F9DFDF',
    orangeyYelow: '#F5A623',
    pale: '#FDEED6',
  },
  icon: {
    cetaceanBlue: '#08044F',
    deepSkyBlue: main.deepSkyBlue,
    lightSeaGreen: '#1EBDAF',
    orangeRed: '#FF554D',
    ripeMango: '#FFBC27',
  },
  neutral: {
    darkCharcoal: '#2F2F2F',
    davysGrey: '#5C5C5C',
    gray: '#808080',
    spanishGrey: '#999999',
    silverSand: '#C6C6C6',
    platinum: '#E8E8E8',
    cultured: '#F4F4F4',
    cultured2: '#F8F8F8',
    white: '#FFFFFF',
  },
}
